export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const confirmOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const agentColumns = [
  { id: "firstName", label: "First Name" },
  { id: "lastName", label: "Last Name" },
  { id: "email", label: "Email" },
  { id: "mobileCode", label: "Mobile Code" },
  { id: "mobileNumber", label: "Mobile Number" },
  { id: "balanceAmount", label: "Balance Amount" },
  { id: "createdBy", label: "Created By" },
  { id: "createdDate", label: "Created At" },
];

export const customerColumns = [
  { id: "ownerPhoneNo", label: "Owner Phone No" },
  { id: "ownerFullName", label: "Owner Full Name" },
  { id: "driverFullName", label: "Driver Full Name" },
  { id: "driverPhoneNo", label: "Driver Phone No" },
  { id: "createdBy", label: "Created By" },
  { id: "createdDate", label: "Created At" },
  { id: "isBlocked", label: "Status" },
];

export const scheduleFinesColumns = [
  { id: "offenceCode", label: "Offence Code" },
  { id: "offenceDetail", label: "Offence Detail" },
  { id: "provision", label: "Provision" },
  { id: "fineAmount", label: "Fine Amount" },
  { id: "createdBy", label: "Created By" },
  { id: "createdDate", label: "Created At" },
];

export const roles = [
  { label: "System Administrator", value: "SystemAdministrator" },
  { label: "Finance", value: "Finance" },
  { label: "Audit", value: "Audit" },
  { label: "RSC Officer", value: "RSCOfficer" },
];

export const usersColumns = [
  { id: "name", label: "Name" },
  { id: "email", label: "Email" },
  { id: "phoneNo", label: "Phone Number" },
  { id: "roleName", label: "Role" },
  { id: "createdDate", label: "Created Date" },
  { id: "updatedDate", label: "Updated Date" },
];

export const transactionsColumns = [
  { id: "referenceNo", label: "Reference No" },
  { id: "transactionType", label: "Transaction Type" },
  { id: "fromName", label: "From Name" },
  { id: "fromRole", label: "From Role" },
  { id: "toName", label: "To Name" },
  { id: "toRole", label: "To Role" },
  { id: "amount", label: "Amount" },
  { id: "commission", label: "Commission" },
  { id: "fee", label: "Fee" },
  { id: "description", label: "Description" },
  { id: "status", label: "Status" },
  { id: "createdBy", label: "Created By" },
  { id: "createdDate", label: "Created Date" },
];

export const balanceChangeColumns = [
  { id: "changeType", label: "Change Type" },
  { id: "userName", label: "User Name" },
  { id: "role", label: "Role" },
  { id: "previousBalance", label: "Previous Balance" },
  { id: "transactionAmount", label: "Transaction Amount" },
  { id: "newBalance", label: "New Balance" },
  { id: "remarks", label: "Remarks" },
  { id: "createdDate", label: "Created Date" },
  { id: "createdBy", label: "Created By" },
];

export const imposedFinesColumns = [
  { id: "fineReferenceCode", label: "Fine Reference Code" },
  { id: "customerName", label: "Customer Name" },
  { id: "customerPhone", label: "Customer Phone" },
  { id: "driverPhone", label: "Driver Phone" },
  { id: "vehicleRegNo", label: "Vehicle Reg. No." },
  { id: "fineType", label: "Fine Type" },
  { id: "offenceCode", label: "Offence Code" },
  { id: "clampUID", label: "Clamp UID" },
  { id: "impoundYardId", label: "Impound Yard ID" },
  { id: "amount", label: "Amount", flex: 1, type: "number" },
  { id: "provision", label: "Provision" },
  { id: "fineStatus", label: "Fine Status" },
  { id: "comments", label: "Comments" },
  { id: "createdBy", label: "Created By" },
  {
    id: "createdDate",
    label: "Created Date",
  },
];

export const vehicleBlacklistColumns = [
  { id: "refId", label: "Reference ID" },
  { id: "vehicleRegNo", label: "Vehicle Registration No" },
  { id: "reason", label: "Reason" },
  { id: "createdByName", label: "Created By" },
  { id: "createdDate", label: "Created Date" },
];

export const vehicleWarningsColumns = [
  { id: "refId", label: "Reference ID" },
  { id: "vehicleRegNo", label: "Vehicle Registration No" },
  { id: "reason", label: "Reason" },
  { id: "warningCount", label: "Warning Count" },
  { id: "createdByName", label: "Created By" },
  { id: "createdDate", label: "Created Date" },
];
export const fineReportColumns = [
  { id: "fineReferenceCode", label: "Fine Reference Code" },
  { id: "customerName", label: "Customer Name" },
  { id: "vehicleRegNo", label: "Vehicle Registration No" },
  { id: "fineType", label: "Fine Type" },
  { id: "offenceCode", label: "Offence Code" },
  { id: "impoundYardId", label: "Impound Yard" },
  { id: "amount", label: "Amount" },
  { id: "provision", label: "Provision" },
  { id: "fineStatus", label: "Fine Status" },
  { id: "comments", label: "Comments" },
  { id: "createdBy", label: "Created By" },
  { id: "createdDate", label: "Created Date" },
];

export const collectionColumns = [
  { id: "fromName", label: "From Name" },
  { id: "fromRole", label: "From Role" },
  { id: "toName", label: "To Name" },
  { id: "toRole", label: "To Role" },
  { id: "amount", label: "Amount" },
  { id: "commission", label: "Commission" },
  { id: "fee", label: "Fee" },
  { id: "transactionType", label: "Transaction Type" },
  { id: "referenceNo", label: "Reference No" },
  { id: "description", label: "Description" },
  { id: "status", label: "Status" },
  { id: "createdBy", label: "Created By" },
  { id: "createdDate", label: "Created Date" },
];

export const statePerformanceColumns = [
  { id: "nameOfStation", label: "Name of Station" },
  { id: "totalFines", label: "Total Fines" },
  { id: "rank", label: "Rank" },
];

export const agentCollectionSummaryColumns = [
  { id: "agentName", label: "Agent Name" },
  { id: "agentRole", label: "Agent Role" },
  { id: "totalTransactions", label: "Total Transactions" },
  { id: "totalAmount", label: "Total Amount" },
  { id: "totalCommission", label: "Total Commission" },
  { id: "totalFee", label: "Total Fee" },
];

export const agentCollectionLogColumns = [
  { id: "toName", label: "To Name" },
  { id: "toRole", label: "To Role" },
  { id: "amount", label: "Amount" },
  { id: "commission", label: "Commission" },
  { id: "fee", label: "Fee" },
  { id: "transactionType", label: "Transaction Type" },
  { id: "referenceNo", label: "Reference" },
  { id: "description", label: "Description" },
  { id: "status", label: "Status" },
  { id: "createdDate", label: "Created Date" },
  { id: "createdBy", label: "Created By" },
];

const reportRoles = [
  "SystemAdministrator",
  "Admin",
  "Finance",
  "Audit",
  "RSCOfficer",
];

export const reportTypes = [
  {
    label: "Fines Report",
    value: "finesReport",
    permissins: reportRoles,
  },
  {
    label: "Collection Report",
    value: "collectionReport",
    permissins: reportRoles,
  },
  {
    label: "Station Performance Report",
    value: "stationPerformanceReport",
    permissins: reportRoles,
  },
  {
    label: "Agent Collection Report",
    value: "agentCollectionReport",
    permissins: reportRoles,
  },
];

export const stationsList = [
  { label: "Bo", value: "Bo" },
  { label: "Kenema", value: "Kenema" },
  { label: "Kono", value: "Kono" },
  { label: "Makeni", value: "Makeni" },
  { label: "Kabala", value: "Kabala" },
  { label: "Kambia", value: "Kambia" },
  { label: "Kailahun", value: "Kailahun" },
  { label: "Portloko", value: "Portloko" },
  { label: "Magburaka", value: "Magburaka" },
  { label: "Mile 6", value: "Mile 6" },
  { label: "Pademba Road", value: "Pademba Road" },
  { label: "Portee", value: "Portee" },
  { label: "Kissy Road", value: "Kissy Road" },
  { label: "Moyamba", value: "Moyamba" },
  { label: "Pujehun", value: "Pujehun" },
  { label: "Mattru Jong", value: "Mattru Jong" },
];
